// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csSemiMonthlyFrequencyV1', ['bmHttpUtils', 'bluemoon.components.session']).service('csSemiMonthlyFrequencyV1',
        ['$http', 'bmHttpUtils',
        function($http, bmHttpUtils) {
            return {
                getList: function(suppressErrors) {
                    var url = '/api/core/v1/semi-monthly-frequencies';
                    return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                        $http({url: url, method: 'GET', params: {}, headers: {} }), suppressErrors);
                }

            };
        }]);
}(window.angular));
